import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Button from '@material-ui/core/Button';
import ConfirmationIconButton from '../common/ConfirmationIconButton';
import Paper from '@material-ui/core/Paper';
import DeleteIcon from '@material-ui/icons/Delete';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { actions } from '../../actions/zoneTypesActions';
import { connect } from 'react-redux';
import routePaths from '../../routePaths';
import EmptyState from '../common/EmptyState';
import './ZoneTypesListPageStyles.scss';

class ZoneTypesListPage extends React.Component {
  constructor(props) {
    super(props);
    this.renderZoneListItem = this.renderZoneListItem.bind(this);
  }

  componentDidMount() {
    this.props.actions.loadZoneTypes();
  }

  handleNavigateToDetails(id) {
    this.props.history.push(`${routePaths.zoneTypes}/${id}`);
  }

  handleDeleteConfirmed(id) {
    this.props.actions.deleteZoneType(id);
  }

  renderZoneListItem(zoneType, index) {
    return (
      <ListItem
        key={index}
        button
        onClick={() => this.handleNavigateToDetails(zoneType.id)}>
        <ListItemText primary={zoneType.name} />
        <ListItemSecondaryAction>
          <ConfirmationIconButton
            confirmationTitle="Usuwanie typu strefy"
            confirmationText={`Czy na pewno chcesz usunąć typ strefy ${zoneType.name}?`}
            onConfirm={() => this.handleDeleteConfirmed(zoneType.id)}
            onCancel={() => { }}
            tooltip="Usuń typ strefy"
            aria-label="Usuń typ strefy"
          >
            <DeleteIcon />
          </ConfirmationIconButton>
        </ListItemSecondaryAction>
      </ListItem>
    );
  }

  render() {
    const { zoneTypes } = this.props;
    return (
      <div className="page">
        <div style={{ margin: 40 }}>
          <div style={{ textAlign: 'right', marginBottom: 16 }}>
            <Button variant="contained" component={Link} color="primary" to={routePaths.createZoneType}>Dodaj typ strefy</Button>
          </div>
          <Paper elevation={3} className="list-panel">
            <List>
              {zoneTypes.length
                ? zoneTypes.map(this.renderZoneListItem)
                : <EmptyState message={'Brak danych'} />}
            </List>
          </Paper>
        </div>
      </div>
    );
  }
}

ZoneTypesListPage.propTypes = {
  actions: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  zoneTypes: PropTypes.array.isRequired,
};


function mapStateToProps(state) {
  return {
    zoneTypes: state.zoneTypes.list,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ZoneTypesListPage);
